import { Link, LinkProps, useMatch, useResolvedPath } from 'react-router-dom'
interface CustomLinkProp extends LinkProps {
    end? :boolean
    onMatchClass?: string
}
export const NavigationLink = ({ children, to, end = false, ...props }: CustomLinkProp) => {
    let resolved = useResolvedPath(to)
    let match = useMatch({ path: resolved.pathname, end: end })
    
    const baseStyle = props.className
    let otherProps = {...props}
    if(typeof otherProps['onMatchClass'] === 'string') delete otherProps['onMatchClass']
    
    return (
        <Link 
        {...otherProps}
            className={`${baseStyle} ${
                match
                    ? props.onMatchClass
                    : ''
            }`}
            to={to}
        >
            {children}
        </Link>
    )
}
